import type { RoadSectionId } from '../../domain/Reference';
import { createCommand } from '../../utils';
import { selectedIdsQuery } from '../queries';
import { SelectRoadSectionsCommand } from './SelectRoadSectionsCommand';

// The "×" of a retained section in the multi-selection panel. Down to one section the panel becomes the
// object sheet; down to none it closes.
export const RemoveFromSelectionCommand = createCommand<RoadSectionId>(
    'MAP_V2/REMOVE_FROM_SELECTION',
    async (id, { dispatch, getState }) => {
        await dispatch(
            SelectRoadSectionsCommand({ ids: selectedIdsQuery(getState()).filter((other) => other !== id) }),
        );
    },
);
